import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { GuideAuthLoading } from '@/components/guides/GuideAuthLoading';
import { useAuth } from '@/lib/auth/client-auth';
import { buildGuideSignupRedirect, resolveGuideAccess } from '@/lib/guides/guide-auth';

/**
 * Kiersten's four gift guides require a Roam Together account.
 * Unsigned visitors go to signup with a return URL; signed-in users read normally.
 */
export function RequireGuideAuth({ children }: { children: ReactNode }) {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();
  const decision = resolveGuideAccess(isLoaded, Boolean(isSignedIn));

  if (decision === 'loading') return <GuideAuthLoading />;
  if (decision === 'redirect') {
    return <Navigate to={buildGuideSignupRedirect(location.pathname, location.search)} replace />;
  }

  return <>{children}</>;
}
